import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AssignmentConfirmDialogComponent } from '@macs-frontend/features/shared/components/assignment-confirm-dialog/assignment-confirm-dialog.component';
import { UUID } from '@macs-frontend/core/utils/uuid';

@Injectable({
  providedIn: 'root',
})
export class TimeslotConfirmationDialogService {
  constructor(private dialog: MatDialog) {}

  openFormDialog(data: {
    uuid: UUID;
    date: string;
    startTime: string;
    endTime: string;
  }): Observable<any> {
    const dialogRef = this.dialog.open(AssignmentConfirmDialogComponent, {
      data,
      panelClass: 'md-modal-container',
    });

    return dialogRef.afterClosed();
  }
}
